import { CategoryTypeEnum } from '@shared/api/models';
import { QuestionsType } from '@shared/api/rest/survey';
import clsx from 'clsx';
import { FieldError } from 'react-hook-form';

interface TextAnswerType {
  className: string;
  caption: string;
  value: QuestionsType[] | null;
  title?: string;
  question: QuestionsType;
  type: number;
  error?: FieldError;
  onChange: (e: string) => void;
}

export const TextAnswer = (props: TextAnswerType) => {
  const isDefault = props.type === CategoryTypeEnum.DefaultText || null;
  const isTextArea = props.type === CategoryTypeEnum.TextArea;
  return (
    <div className={clsx(props.className, 'rounded relative  w-full')}>
      {isDefault && (
        <div className={clsx('text-left border-b border-gray-400 pb-5')}>
          <div className='mx-5'>
            <h3 className='text-[22px] text-[#2c3344] font-semibold'>{props.title}</h3>
            <div className='text-[13px] font-normal'>{props.caption}</div>
          </div>
        </div>
      )}
      {isTextArea && (
        <div className='mx-5 relative'>
          <textarea
            className={clsx(
              'border border-gray-400 rounded hover:shadow-[0_0_0_3px_rgba(46,105,255,0.5)] focus:shadow-[0_0_0_4px_rgba(46,105,255,0.5)] min-h-[170px]',
              'tracking-[1.58px] leading-normal m-0 outline-none resize-y w-full text-base bg-[#fcfbf5]',
              'pt-3 px-4 ',
              'placeholder:text-base placeholder:font-normal placeholder:antialiased placeholder:tracking-[0.5px] ',
            )}
            onChange={(e) => props.onChange(e.target.value)}
            placeholder={props.caption}
          />
          {props.error && <div className='text-[#d00000] text-sm mt-2.5 max-w-[744px] w-full'>This field is required</div>}
        </div>
      )}
    </div>
  );
};
